import React from 'react';
const IMSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-im" });
IMSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-im sirius-icon-im-enhance" });
export default IMSvg;
